import { openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c36946f8")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("i", {
    class: ["icon", [`icon${_ctx.version === 1 ? '' : `v${_ctx.version}`}-${_ctx.name_}`, { xs: _ctx.xs, sm: _ctx.sm, lg: _ctx.lg }]]
  }, null, 2))
})